import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import axiosInstance from '../services/axiosInstance';
import axios from 'axios';
import { io } from 'socket.io-client';

export const useCredits = () => {
  const { user } = useAuth();
  const [credits, setCredits] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCredits = useCallback(async () => {
    if (!user) return;
    
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/credits`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      console.log('Credits response:', response.data);
      setCredits(response.data.credits?.credits || 0);
      setSubscription(response.data.subscription);
    } catch (error) {
      console.error('Error fetching credits:', error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [user]);

  const deductCredits = async () => {
    if (!user) return false;

    try {
      console.log('Deducting credits');
      const response = await axiosInstance.post('/api/credits/deduct');
      console.log('Deduction response:', response.data);
      
      if (response.data.unlimited) {
        return true;
      }

      if (response.data.success) {
        setCredits(response.data.credits?.credits || 0);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error deducting credits:', error);
      return false;
    }
  };

  useEffect(() => {
    if (user) {
      fetchCredits();
    }
  }, [user, fetchCredits]);

  useEffect(() => {
    if (!user) return;

    // Connect to WebSocket
    const socket = io(process.env.REACT_APP_API_URL, {
      auth: {
        token: localStorage.getItem('token')
      }
    });

    // Listen for credit updates
    socket.on('credits_updated', (data) => {
      if (data.userId === user.id) {
        console.log('Received credit update:', data);
        setCredits(data.credits);
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [user]);

  return {
    credits,
    subscription,
    loading,
    error,
    refetchCredits: fetchCredits,
    deductCredits
  };
}; 